import { ref, computed, watch } from 'vue';

export default (props, { emit }) => {
  const dialogComputed = computed({
    get: () => props.modelValue,
    set: (value) => emit('update:modelValue', value)
  });

  const selectedSubItems = computed(() => props.selectedSubItems);

  // Declared before localSelectedTeam, which reads it during setup
  const firstTeamId = computed(() => Object.keys(props.teamUsers)[0] || '');

  const localSelectedTeam = ref(props.selectedTeam.length ? String(props.selectedTeam) : firstTeamId.value);
  const selectedUsers = ref([]);

  const getInitials = (name) => {
    const words = name.split(' ');
    if (words.length >= 2) {
      return (words[0][0] + words[1][0]).toUpperCase();
    } else {
      return words[0].substring(0, 2).toUpperCase();
    }
  };
  
  const getRandomColor = (id) => {
    const colors = ['#F44336', '#E91E63', '#9C27B0', '#673AB7', '#3F51B5', '#2196F3', '#03A9F4', '#00BCD4', '#009688', '#4CAF50', '#8BC34A', '#CDDC39', '#FFC107', '#FF9800', '#FF5722'];
    const index = id.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0) % colors.length;
    return colors[index];
  };

  const getAvatarUrl = (avatarUrl) => {
    if (!avatarUrl) {
      return '';
    }
    let finalUrl = '';
    // If the URL already includes a protocol, return as-is
    if (avatarUrl.startsWith('http://') || avatarUrl.startsWith('https://')) {
      finalUrl = avatarUrl;
    } else {
      // Otherwise, prepend https://
      finalUrl = 'https://' + avatarUrl;
    }
    return finalUrl;
  };

  // Badge count across every item the project has, not just the loaded page (R13)
  const getUserItemCount = (userId) => {
    let count = 0;

    props.allItems.forEach(item => {
      if (item.subItems) {
        item.subItems.forEach(subItem => {
          if (subItem.assigneeUserIds && subItem.assigneeUserIds.includes(userId)) {
            count += 1;
          }
        });
      }
    });

    return count;
  };
  
  const closeDialog = () => {
    dialogComputed.value = false;
  };

  const assignTeam = () => {
    emit('assign', {
      teamId: String(localSelectedTeam.value),
      userIds: selectedUsers.value.map(String),
      subItemIds: [...selectedSubItems.value]
    });
  };

  const toggleUserSelection = (userId) => {
    const index = selectedUsers.value.indexOf(userId);
    if (index === -1) {
      selectedUsers.value.push(userId);
    } else {
      selectedUsers.value.splice(index, 1);
    }
  };

  const selectAllUsers = () => {
    const users = props.teamUsers[localSelectedTeam.value] || [];
    selectedUsers.value = users.map(user => user.id);
  };

  const deselectAllUsers = () => {
    selectedUsers.value = [];
  };

  watch(() => props.selectedTeam, (newValue) => {
  localSelectedTeam.value = newValue.length ? String(newValue) : firstTeamId.value;
  }, { immediate: true });

  // selectedSubItems is the local computed, which shadows the prop of the same
  // name exactly as it did under <script setup> (setup state wins over props)
  return {
    dialogComputed,
    selectedSubItems,
    localSelectedTeam,
    selectedUsers,
    getInitials,
    getRandomColor,
    getAvatarUrl,
    getUserItemCount,
    closeDialog,
    assignTeam,
    toggleUserSelection,
    selectAllUsers,
    deselectAllUsers
  };
};
